import { PageFrame } from "../../components/page_frame";
import { InventoryWosCoraContainer } from "./container";

export default function InventoryWosCoraPage() {
  return (
    <PageFrame>
      <InventoryWosCoraContainer />
    </PageFrame>
  );
}
